interface NavItem {
  name: string;
  path: string;
}

export const useNavHistory = () => {
  const addToHistory = (program: NavItem) => {
    if (!import.meta.client) return;

    const history: NavItem[] = JSON.parse(localStorage.getItem('navHistory') || '[]');

    const filtered = history.filter((p) => p.path !== program.path);

    filtered.unshift({
      name: program.name,
      path: program.path,
    });

    localStorage.setItem('navHistory', JSON.stringify(filtered.slice(0, 3)));
  };

  const getHistory = (): NavItem[] => {
    if (!import.meta.client) return [];

    return JSON.parse(localStorage.getItem('navHistory') || '[]');
  };

  return { addToHistory, getHistory };
};
